// Plain module (no 'use client') so both the client Faq component and server
// components can consume the list — client-module exports are opaque
// references inside RSC and cannot be iterated there.
export const FAQ_ITEMS = ['launch', 'data', 'mobile', 'privacy', 'roster'] as const
